import type { FreelancerAvailabilityLocales } from '../types';

const freelancerAvailabilityLocales: FreelancerAvailabilityLocales = {
  availabilitySaved: 'Availability saved!',
  endDateIsRequiredWhenRepeating: 'End date is required when repeating.',
  enterBothStartAndEndTimeOrLeaveBothBlank:
    'Enter both start and end time or leave both blank.',
  LeaveStartAndEndTimeBlankIfYouAreAvailableAllday:
    'Leave start and end time blank if you are available all day.',
  perMonth: 'Per Month',
  perWeek: 'Per Week',
  repeatDateMustBeLessThan6Months: 'Repeat date must be less than 6 months.',
  startDateMustBeLessThanEndDate: 'Start date must be less than end date.',
  toRepeat: 'To repeat',
  UseThisDailyAvailabilityForALongerPeriodOfTime:
    'Use this daily availability for a longer period of time ',
};

export default freelancerAvailabilityLocales;
